import { types } from "mobx-state-tree";
const snackbarsStoreModel = types
    .model({
    snackbars: types.array(types.maybeNull(types.model({
        element: types.frozen(),
        visible: types.boolean,
    }))),
})
    .actions((self) => {
    const actions = {
        hideSnackbar(index) {
            const snackbar = self.snackbars[index];
            if (snackbar) {
                snackbar.visible = false;
            }
        },
        addSnackbar(element, options = {}) {
            const index = self.snackbars.length;
            const { hideTimeout = 5000 } = options;
            self.snackbars.push({
                element,
                visible: true,
            });
            setTimeout(() => {
                actions.hideSnackbar(index);
            }, hideTimeout);
            setTimeout(() => {
                actions.deleteSnackbar(index);
            }, hideTimeout + 1000);
        },
        deleteSnackbar(index) {
            if (self.snackbars.length <= index) {
                return;
            }
            self.snackbars[index] = null;
        },
        clearAll: () => {
            self.snackbars.clear();
        },
    };
    return actions;
})
    .views((self) => ({
    getActiveSnackbars: () => self.snackbars.filter((s) => s !== null),
}));
/** Global store that handles snackbar instances */
export const snackbarsStore = snackbarsStoreModel.create();
export default snackbarsStore;
//# sourceMappingURL=data:application/json;base64,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